<template>
  <v-dialog v-model="show" max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="object.extra"
              :items="extrasArr"
              dense
              label="Extras"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" class="text-center">
            <v-text-field
              type="text"
              dense
              v-model="object.precio"
              label="Precio"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!detalle" color="blue darken-1" text @click="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      nombre: this.object.nombre,
      extrasArr: [],
    };
  },
  props: {
    object: Object,
    show: Boolean,
    update: Boolean,
    detalle: Boolean,
  },
  created() {
    this.selectExtrasFn();
  },
  computed: {
    ...mapState("extraNamespace", ["extra", "extras"]),
    formTitle() {
      let me = this;
      let titulo = "";
      if (me.update) {
        titulo = "Edición de registro";
      } else if (me.detalle) {
        titulo = "Detalle";
      } else {
        titulo = "Nuevo registro";
      }
      // this.update ? "Edución de registro" : "Nuevo registro";
      return titulo;
    },
  },
  methods: {
    selectExtrasFn() {
      let me = this;
      let arr = this.extras;
      arr.forEach((x) => {
        me.extrasArr.push({ text: x.nombre, value: x.id });
      });
    },
    guardar() {
      this.$emit("save", this.object);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
